import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import MachineryList from './pages/MachineryList';
import MachineryDetail from './pages/MachineryDetail';
import Maintenance from './pages/Maintenance';
import MaintenanceDetail from './pages/MaintenanceDetail';
import SpareParts from './pages/SpareParts';
import DailyReports from './pages/DailyReports';
import Operators from './pages/Operators';
import Reports from './pages/Reports';
import WorkReports from './pages/WorkReports';
import MaterialRequests from './pages/MaterialRequests';
import Purchases from './pages/Purchases';
import Users from './pages/Users';
import Roles from './pages/Roles';
import Companies from './pages/Companies';
import AuditLogs from './pages/AuditLogs';
import WorkOrders from './pages/WorkOrders';
import WorkOrderDetail from './pages/WorkOrderDetail';
import Checklists from './pages/Checklists';
import FuelModule from './pages/FuelModule';
import Layout from './components/Layout';
import PushNotifications from './components/PushNotifications';
import { Toaster } from './components/ui/sonner';
import './App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const AuthContext = React.createContext(null);

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    setLoading(false);
  }, []);

  const login = (token, userData) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg">Cargando...</div>
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      <BrowserRouter>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/login" element={!user ? <Login /> : <Navigate to="/" />} />
          <Route
            path="/*"
            element={
              user ? (
                <>
                  <PushNotifications />
                  <Layout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/machinery" element={<MachineryList />} />
                    <Route path="/machinery/:id" element={<MachineryDetail />} />
                    <Route path="/maintenance" element={<Maintenance />} />
                    <Route path="/maintenance/:id" element={<MaintenanceDetail />} />
                    <Route path="/spare-parts" element={<SpareParts />} />
                    <Route path="/daily-reports" element={<DailyReports />} />
                    <Route path="/operators" element={<Operators />} />
                    <Route path="/reports" element={<Reports />} />
                    <Route path="/work-reports" element={<WorkReports />} />
                    <Route path="/material-requests" element={<MaterialRequests />} />
                    <Route path="/purchases" element={<Purchases />} />
                    <Route path="/work-orders" element={<WorkOrders />} />
                    <Route path="/work-orders/:id" element={<WorkOrderDetail />} />
                    <Route path="/checklists" element={<Checklists />} />
                    <Route path="/fuel" element={<FuelModule />} />
                    <Route path="/users" element={<Users />} />
                    <Route path="/roles" element={<Roles />} />
                    <Route path="/companies" element={<Companies />} />
                    <Route path="/audit-logs" element={<AuditLogs />} />
                  </Routes>
                </Layout>
                </>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthContext.Provider>
  );
}

export default App;